import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { StepsMainContainer } from "./FormStepsElements";

const steps = [
  {
    label: "Persona Natural o Jurídica",
    description: `Cuéntanos si eres persona natural o jurídica.
	Natural: La inversión es para tu beneficio personal.
	Jurídica: La inversión es para tu empresa.`,
  },
  {
    label: "Conoce los Requisitos",
    description:
      "Ten preparado los siguientes documentos que te vamos a solicitar en el formulario.",
  },
  {
    label: "Completa Nuestro Formulario",
    description: `Asegúrate de completar todos los campos del siguiente formulario.`,
  },
];

const FormSteps = () => {
  return (
    <StepsMainContainer
      style={{
        position: "fixed",
        top: "140px",
        right: "0px",
      }}
    >
      <Box sx={{ maxWidth: 400, marginTop: "-180px" }}>
        <Stepper activeStep={2} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                optional={
                  index === 2 ? (
                    <Typography variant="caption">Último Paso</Typography>
                  ) : null
                }
              >
                {step.label}
              </StepLabel>
              <StepContent>
                <Typography>{step.description}</Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </StepsMainContainer>
  );
};

export default FormSteps;
